import { BaseApiTemplateService, Core2Config } from '../../../shared';
import { TaskCampaignLinkContainerModel } from '../../../../../../../models/aggregates/alg/cc/task';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class TaskCampaignLinkService extends BaseApiTemplateService<TaskCampaignLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ALG_CC_MODULE +
      'task-campaign-links';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ALG_CC_MODULE +
      'task-campaign-links';
    this.httpClient = http;
  }
}
